import { createFileRoute } from '@tanstack/react-router';
import EditTitle from '~/containers/Experiences/EditTitle';

export const Route = createFileRoute('/experiences/$experienceId/edit-title')({
  component: EditTitle,
});
